import { z } from "zod/v4";
import { requiredVizLabelEntriesSchema } from "@/lib/ai/visualization/views/shared/label-map";
import {
  chartExportFormatsSchema,
  vizAxisDirectionsSchema,
  vizAxisPresetSchema,
  vizPaletteModeSchema,
  vizReferenceAreaSchema,
  vizReferenceLineSchema,
  vizSeriesArraySchema,
  vizSeriesLabelMapSchema,
  vizTooltipModeSchema,
  vizXAxisTicksSchema,
} from "@/lib/ai/visualization/views/shared/schema-primitives";
import {
  vizSeriesToggleModeSchema,
  vizStackingSchema,
  vizTimeSeriesYAxisModeSchema,
} from "@/lib/ai/visualization/views/shared/view-options";

/**
 * `time-series-area` authoring contract。
 */
export const timeSeriesAreaAuthoringSchema = z
  .object({
    xKey: z.string().min(1),
    xLabel: z.string().trim().min(1),
    seriesKeys: z.array(z.string().min(1)).min(1),
    seriesLabelEntries: requiredVizLabelEntriesSchema,
  })
  .strict();

/**
 * `TimeSeriesArea` runtime component props schema。
 */
export const timeSeriesAreaComponentSchema = z
  .object({
    dataPath: z.string(),
    xKey: z.string(),
    series: vizSeriesArraySchema,
    xLabel: z.string().optional().nullable(),
    seriesLabels: vizSeriesLabelMapSchema,
    periodLabels: z
      .object({
        current: z.string().optional().nullable(),
        comparison: z.string().optional().nullable(),
      })
      .strict()
      .optional()
      .nullable(),
    chartHeight: z.number().int().min(280).max(420).optional().nullable(),
    axisDirections: vizAxisDirectionsSchema,
    axisPreset: vizAxisPresetSchema,
    tooltipMode: vizTooltipModeSchema,
    paletteMode: vizPaletteModeSchema,
    yAxisMode: vizTimeSeriesYAxisModeSchema.optional().nullable(),
    stacking: vizStackingSchema.optional().nullable(),
    xAxisTicks: vizXAxisTicksSchema,
    referenceLines: z
      .array(vizReferenceLineSchema)
      .max(6)
      .optional()
      .nullable(),
    referenceAreas: z
      .array(vizReferenceAreaSchema)
      .max(4)
      .optional()
      .nullable(),
    allowSeriesToggle: z.boolean().optional().nullable(),
    seriesToggleMode: vizSeriesToggleModeSchema.optional().nullable(),
    defaultVisibleSeriesKeys: z.array(z.string()).optional().nullable(),
    allowExport: z.boolean().optional().nullable(),
    exportFormats: chartExportFormatsSchema,
  })
  .strict();
